export default __webpack_public_path__ + "static/media/heart.9ebf6c86.ogg";